import styled from 'styled-components';

import {
  Grid as SemanticGrid,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  padding: 0px 10px;
`;

const Grid = styled(SemanticGrid)`
  &&& {
    margin: 0px;
  }
`;

const Row = styled(SemanticGrid.Row)`
`;

const HeaderRow = styled(SemanticGrid.Row)`
  &&& {
    padding: 0px;
  }
`;

const Column = styled(SemanticGrid.Column)`
`;

const Header = styled(TextLayoutComponent.Bold)`
`;

const Data = styled(TextLayoutComponent)`
`;

const NoDataMessage = styled(TextLayoutComponent)`
  margin-top: 20px;
`;

const ExipireButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    color: ${(props) => props.theme.color.removed}
  }
`;

export {
  Column,
  Container,
  Data,
  Grid,
  Header,
  NoDataMessage,
  Row,
  ExipireButton,
  HeaderRow,
};
